<template>
    <div class="container animated slideInDown">
        <div class="cate">
            简介
        </div>
        <div class="intro" v-html="baseConfig.intro"></div>
        <div class="base-info">
            <div class="base-item">
                <div class="name">名称</div>
                <div class="info">{{baseConfig.full_name}}</div>
            </div>
            <div class="base-item">
                <div class="name">英文全称</div>
                <div class="info">{{baseConfig.full_name_en}}
                </div>
            </div>
            <div class="base-item">
                <div class="name">地址</div>
                <div class="info">{{baseConfig.address}}</div>
            </div>
            <div class="base-item">
                <div class="name">联系方式</div>
                <div class="info">{{baseConfig.link_type}}</div>
            </div>
        </div>
        <div class="cate">
            历程
        </div>
        <div class="history">
            <div class="history-item">
                <div class="year">
                    2017年
                </div>
                <div style="flex-grow: 1">
                    <div class="month-main">
                        <div class="month"><span>7月</span></div>
                        <div class="history-info">非遗与数字化中心成立</div>
                    </div>
                    <div class="month-main">
                        <div class="month"><span>12月</span></div>
                        <div class="history-info">第一期合作活动成功举办</div>
                    </div>
                </div>
            </div>
            <div class="history-item">
                <div class="year">
                    2019年
                </div>
                <div style="flex-grow: 1">
                    <div class="month-main">
                        <div class="month"><span>3月</span></div>
                        <div class="history-info">非遗与数字化中心成立，非遗与数字化中心成立非遗与数字化中心成立</div>
                    </div>
                    <div class="month-main">
                        <div class="month"><span>7月</span></div>
                        <div class="history-info">第一期合作活动成功举办</div>
                    </div>
                </div>
            </div>
            <div class="history-item">
                <div class="year">
                    2020年
                </div>
                <div style="flex-grow: 1">
                    <div class="month-main">
                        <div class="month"><span>4月</span></div>
                        <div class="history-info">非遗与数字化中心成立</div>
                    </div>
                    <div class="month-main">
                        <div class="month"><span>9月</span></div>
                        <div class="history-info">第一期合作活动成功举办</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="cate">
            图集
        </div>
        <div class="images-container">
            <div class="image" :style="'background-image:url('+item+')'" :key="'pic_'+index" v-for="(item,index) in baseConfig.intro_pics"></div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import scene1 from "@/assets/images/scene1.png"
    import scene2 from "@/assets/images/scene2.png"
    import scene3 from "@/assets/images/scene3.png"

    export default {
        name: "about-us",
        data() {
            return {
                scene1, scene2, scene3
            }
        },
        computed: {
            ...mapGetters([
                'component', 'baseConfig'
            ]),
        }
    }
</script>

<style scoped lang="less">
    .container {
        width: 1100px;
        background: rgba(255, 255, 255);
        padding: 30px 50px;
        margin: auto;
        height: 80vh;
        border-radius: 10px;
        overflow: scroll;
        .cate {
            font-size: 20px;
            border-bottom: 1px solid #000;
            padding-bottom: 10px;
            margin: 20px 0;
        }
        .intro {
            font-size: 13px;
            line-height: 2;
        }
        .base-info {
            font-size: 13px;
            margin-top: 20px;
            .base-item {
                padding: 25px 0;
                border-top: 1px solid #bcbcbc;
                display: flex;
                .name {
                    color: #5b5b5b;
                    width: 100px;
                }
                .info {
                    flex-grow: 1;
                    color: #000;
                }
            }
            .item:last-child {
                border-bottom: 1px solid #bcbcbc;
            }
        }
        .history {
            font-size: 13px;
            margin-top: 20px;
            .history-item {
                display: flex;
                .year {
                    color: #5b5b5b;
                    width: 100px;
                }
                .month-main {
                    flex-grow: 1;
                    width: 100%;
                    display: flex;
                    margin-bottom: 25px;
                    .month {
                        width: 100px;
                        span {
                            background: orange;
                            color: #fff;
                            padding: 2px 0;
                            width: 60px;
                            border-radius: 20px;
                            display: inline-block;
                            text-align: center;
                        }
                    }
                    .history-info {

                    }
                }
            }
        }
        .images-container {
            overflow: hidden;
            .image {
                width: 21%;
                height: 150px;
                background: #eee;
                background: no-repeat center center;
                background-size: cover;
                float: left;
                margin-right: 20px;
                margin-left: 20px;
                margin-bottom: 40px;
            }
        }
    }
</style>